import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice } from "@grandvisionhq/utils";
/* empty css           */
const Price = ({
  value,
  centAmount = true,
  currency,
  className,
  type = "default",
  size = "custom",
  "aria-label": ariaLabel,
  fixedDecimals,
  prefix,
  ...rest
}) => {
  const { locale } = useIntl();
  const Component = type === "strikethrough" ? "s" : "span";
  const formattedPrice = formatPrice({
    locale,
    value,
    currency,
    isCentAmount: !!centAmount,
    fixedDecimals
  });
  const priceLabel = `${prefix ? `${prefix} ` : ""}${formattedPrice}`;
  const priceContent = React.useMemo(() => {
    if (!ariaLabel) return priceLabel;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, ariaLabel, " "), /* @__PURE__ */ React.createElement("span", null, priceLabel));
  }, [ariaLabel, priceLabel]);
  return /* @__PURE__ */ React.createElement(
    Component,
    {
      ...rest,
      className: classnames("price", `price--${type}`, `price--${size}`, className)
    },
    priceContent
  );
};
export {
  Price as default
};
//# sourceMappingURL=Price.js.map
